import { useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = useCallback(
        async (event) => {
            event.preventDefault();
            setError(null);
            setSubmitting(true);
            try {
                await login(email, password);
                const redirectPath = params.get('redirectTo') || '/';
                navigate(redirectPath, { replace: true });
            } catch (err) {
                const message = err?.message || 'Login failed';
                setError(message);
            } finally {
                setSubmitting(false);
            }
        },
        [email, password, login, navigate, params]
    );

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <h1 className="auth-card__title">Sign in</h1>
                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-field">
                        <label className="form-label" htmlFor="login-email">Email</label>
                        <input
                            id="login-email"
                            type="email"
                            required
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            autoComplete="username"
                        />
                    </div>

                    <div className="form-field">
                        <label className="form-label" htmlFor="login-password">Password</label>
                        <input
                            id="login-password"
                            type="password"
                            required
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            autoComplete="current-password"
                        />
                    </div>

                    {error ? (
                        <div className="auth-error">{error}</div>
                    ) : null}

                    <button type="submit" className="primary-btn auth-submit" disabled={submitting}>
                        {submitting ? 'Signing in…' : 'Sign in'}
                    </button>

                    <div className="auth-footer" style={{ marginTop: '1rem', textAlign: 'center' }}>
                        <p>
                            Don't have an account? <a href="/register" onClick={(e) => { e.preventDefault(); navigate('/register'); }}>Register here</a>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}
